module.exports = __webpack_public_path__ + "static/og-e6a38ade5ec99139d1f1f343c59b58bd.png";